import { render, staticRenderFns } from "./PlatonChart.vue?vue&type=template&id=5eed99fc"
import script from "./PlatonChart.vue?vue&type=script&lang=js"
export * from "./PlatonChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports